import { useQuery } from "@tanstack/react-query";
// API base
import API from "./Api";
// Toastify
import { toast } from "react-toastify";

export default function useGetOneRefundClientApi(id) {
  const fetchOneRefundClient = async () => {
    try {
      const res = await API.get(`api/get-one-refund-client/${id}`);
      return res.data.client;
    } catch (err) {
      console.error(err);
      const errorMessage =
        err?.response?.data?.message || err?.message || "An error occurred";
      // Toastify
      toast.error(errorMessage);
    }
  };

  return useQuery({
    enabled: false, // Disable automatic fetching
    queryKey: ["oneRefundClient", id],
    queryFn: fetchOneRefundClient,
  });
}
